import { render, staticRenderFns } from "./ChiefDeptRegistersView.vue?vue&type=template&id=794712c5"
import script from "./ChiefDeptRegistersView.vue?vue&type=script&lang=js"
export * from "./ChiefDeptRegistersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports